import React from 'react';
import './styles.scss';


const SelectModal = ({options, name,required}) => {

    return(
        <select name={name} className= "Select" required={required}>
                <option  value="" disabled hidden selected>
                    {options.shift().name}
                </option>
            
            {
                options.map((option, index) => {
                    return (
                        <option value={option.value} key={index}>
                            {option.name}
                        </option>
                    )
            })

            }


        </select>


    )



}

export default SelectModal;